import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { RecordedDocumentsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position: number;
};
export const schemaLoanRequestResolver_GetRecordedDocuments = RecordedDocumentsTableDefinitionZod.nullable();

export type SchemaLoanRequestResolver_GetRecordedDocuments = z.infer<
    typeof schemaLoanRequestResolver_GetRecordedDocuments
>;

export type LoanRequestResolver_GetRecordedDocuments = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetRecordedDocuments
>;
